import { CartItem, CartTotal } from "common/features/cart/cartModels";
import {
  EditOrderItem,
  OrderItem,
  OrderTotal,
} from "common/features/order/orderModels";
import { Tax } from "common/features/restaurant/restaurantModels";
import { getDecimalPlacedPrice } from "./menu-helper-utils";

const getCalculatedValue = (amount: number, value: any) => {
  if (value.type == "FLATFEE") {
    return value.rate;
  } else if (value.type == "PERCENT") {
    return amount * (value.rate / 100);
  } else {
    return 0;
  }
};

export const getItemTax = (item: CartItem, serviceCharge: any) => {
  return item.tax.reduce((accumulator: number, currentTax: Tax) => {
    let itemPrice = getDecimalPlacedPrice(item.subTotal);
    const serviceFee =
      serviceCharge.length > 0
        ? getCalculatedValue(itemPrice, serviceCharge[0])
        : 0;

    if (currentTax.type == "FLATFEE") {
      return accumulator + currentTax.rate * +item.quantity;
    } else if (currentTax.type == "PERCENT") {
      let taxPrice = ((itemPrice + serviceFee) * currentTax.rate) / 100;
      return accumulator + taxPrice;
    } else {
      return accumulator;
    }
  }, 0);
};

export const getEditCartItemFromCartItem = (
  items: CartItem[],
  modifiedItemIds: string[]
): any[] => {
  return items.map((item) => {
    return {
      ...item,
      orderItemId: modifiedItemIds.includes(item.itemId) ? item.itemId : null,
      id: item.itemId,
      taxFees: "0.0",
      isItemModified: modifiedItemIds.includes(item.itemId),
      options: item.options.map((option) => {
        return {
          ...option,
          //id: option.modifierOptionId,
          isOptionModified: false,
        };
      }),
    };
  });
};

export const getEditCartItemFromOrderItem = (
  items: OrderItem[],
  modifiedItemIds: string[]
): EditOrderItem[] => {
  return items.map((item) => {
    return {
      ...item,
      taxFees: item.taxFees || "0.0",
      isItemModified: modifiedItemIds.includes(item.id),
      options: item.options.map((option) => {
        return {
          ...option,
          //id: option.id,
          isOptionModified: false,
        };
      }),
    };
  });
};

export const getTotalByCode = (
  totals: CartTotal[] | OrderTotal[],
  code: string
): CartTotal | OrderTotal | null => {
  let totalIndex = totals?.findIndex((total) => +total.code == +code);
  if (totalIndex >= 0) {
    return totals[totalIndex];
  } else {
    return null;
  }
};

export const getTitleByCode = (
totals: CartTotal[] | OrderTotal[],
code: string,
): CartTotal | OrderTotal | null => {
let totalIndex = totals?.findIndex((total) => Number(+total.code) == Number(+code));
if (totalIndex >= 0) {
  return totals[totalIndex];
} else {
  return null;
}
};

export const mergeTotals = (
  cartTotals: CartTotal[],
  orderTotals: OrderTotal[]
): OrderTotal[] => {
  return orderTotals.map((total) => {
    const cartTotal = getTotalByCode(cartTotals, total.code);
    if (cartTotal) {
      return {
        ...total,
        value: (+total.value + +cartTotal.value).toString(),
      };
    } else {
      return total;
    }
  });
};
